import React from 'react';
import ProfileOrcid from 'app/blocks/orcid/ProfileOrcid';

function OrcidPanel() {
    const widgetProps = null;
    return (
        <div>
            <ProfileOrcid {...widgetProps} />
        </div>
    );
}

export default OrcidPanel;
